import React from 'react';
import {usePromiseTracker} from "react-promise-tracker";
import { CardLoagingSkeleton } from '../DommusLoadingSkeleton/CardLoadingSkeleton';

export default function DommusLoadingCardAtendimento({area, children}) {
	const {promiseInProgress} = usePromiseTracker({area: area});

	return (
		promiseInProgress ?
          <CardLoagingSkeleton/>
        : children
	);
}
